import React, { useCallback, useMemo } from 'react';
import { useValueChange } from '@leverege/ui-hooks';
import { CompactPicker } from 'react-color';
import Model from "./ValueColorizer.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ValueColorizerEditor(props) {
  const {
    value,
    id
  } = props;
  const onModelChange = useValueChange(Model, props);
  const {
    byRgb,
    byVar,
    values
  } = useMemo(() => {
    const s = Array.from(document.styleSheets).filter(sheet => sheet.href === null || sheet.href.startsWith(window.location.origin)).reduce((acc, sheet) => {
      return [...acc, ...Array.from(sheet.cssRules).reduce((def, rule) => {
        return rule.selectorText === ':root' ? [...def, ...Array.from(rule.style).filter(name => name.startsWith('--color')).map(name => `var(${name})`)] : def;
      }, [])];
    }, []).filter(name => name.includes('base') || name.includes('brand')).sort((nameA, nameB) => {
      const aIncludesBase = nameA.includes('base');
      const bIncludesBase = nameB.includes('base');
      if (aIncludesBase && bIncludesBase) {
        return nameA > nameB ? 1 : -1;
      }
      if (aIncludesBase) {
        return 1;
      }
      if (bIncludesBase) {
        return -1;
      }
      const aIncludesBrand = nameA.includes('brand');
      const bIncludesBrand = nameB.includes('brand');
      if (aIncludesBrand && bIncludesBrand) {
        return nameA > nameB ? 1 : -1;
      }
      return -1;
    });
    const allWhiteSpace = /\s/g;
    const byVar = {};
    const byRgb = {};
    const values = [];
    Array.from(new Set(s)).slice(0, 36).forEach(color => {
      const div = document.createElement('div');
      div.style = `color: ${color}; display: none;`;
      document.body.appendChild(div);
      const c = window.getComputedStyle(div).color.replace(allWhiteSpace, '');
      document.body.removeChild(div);
      byVar[color] = c;
      byRgb[c] = color;
      values.push(c);
    });
    return {
      byVar,
      byRgb,
      values
    };
  }, []);
  const onChange = useCallback(({
    hex,
    rgb
  }, event) => {
    event.preventDefault();
    let color = hex;
    const rgbString = `rgb(${rgb.r},${rgb.g},${rgb.b})`;
    if (byRgb[rgbString]) {
      color = byRgb[rgbString];
    }
    onModelChange({
      data: 'setColor',
      value: color
    });
  }, [onModelChange, byRgb]);
  const resolvedValue = useMemo(() => {
    const val = Model.getColor(value);
    if (byVar[val]) {
      return byVar[val];
    }
    return val;
  }, [value, byVar]);
  return /*#__PURE__*/_jsx(CompactPicker, {
    id: id,
    colors: values,
    color: resolvedValue || '#000000',
    onChange: onChange
  });
}
ValueColorizerEditor.isInline = true;